import { AssetNewConfig } from './assetNewConfig';
import { AssetNewLoader } from './assetNewInterface';

export function createAssetNewLoader(config: AssetNewConfig): AssetNewLoader {
    const { service } = config;
    return {
        useData(context, props) {
            const find = service.asset.useFind(context, {});
            const create = service.asset.useCreate(context);
            const update = service.asset.useUpdate(context);
            return { find, create, update };
        },
    };
}
